import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { fetchPositions } from '../../../../../Redux/Actions/Admin/ManagePositionActions';
import { getPermissions } from '../../../../../Redux/Actions/Admin/ManageUserActions';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import './SwalAdjust.scss';
import { auth } from '../../../../../services/auth.service';

class UserForm extends Component {
    constructor(props) {
        super(props);
		this.state = {
            userInEdit: this.props.dataItem || null,
            originalEmail: this.props.dataItem? this.props.dataItem.email : '',
            name: '',
            value: [],
            emailMessage: ''
		};
	}

    componentDidMount() {
        const role = 'Internal';
        this.props.getPermissions(role);
        this.props.fetchStates();
        this.props.fetchPositions();
	}

	handleSubmit = (event) => {
		event.preventDefault();
		swal(
			`Are you sure you want to add/update ${this.state.userInEdit.firstName} ${this.state.userInEdit
				.lastName} with the following permissions: ${this.state.userInEdit.permissions.map(
				(item) => ` ${item.claimName}`
			)}.`,
			{
                buttons: ["CANCEL", "OK"]
			}
        ).then((value) => {
            var t = this.state.userInEdit.email;
            switch (value) {
                case true:
                    axios
                        //.get(`${ROOT_API_URL}/ManageUsers/IsDuplicateEmail?email=${this.state.userInEdit.email}`, { headers: auth.authHeader() })
                        .post(`${ROOT_API_URL}/ManageUsers/IsDuplicateEmail`,
                            {
                                email: this.state.userInEdit.email
                            },
                            {
                                headers: auth.authHeader()
                            }
                        )
                        .then((response) => {
                            if (this.state.originalEmail != this.state.userInEdit.email) {
                                this.setState({
                                    emailMessage: response.data.message
                                });
                                if (value && this.state.emailMessage == "") {

                                    if (this.state.userInEdit.userID) {
                                        this.props.modify(this.state.userInEdit);
                                        this.props.cancel();
                                    } else {
                                        this.props.add(this.state.userInEdit);
                                        this.props.cancel();
                                    }
                                }
                            }
                            else {
                                this.props.modify(this.state.userInEdit);
                                this.props.cancel();
                            }
                        })
                        .catch((response) => {
                            console.log(response);
                        });
                case "CANCEL":
                    swal.close();
                    break;
            }
            
		});
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.userInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			userInEdit: edited
        });

        if (name == "email") {
            this.setState({
                emailMessage: ''
            });
        }
	};

    handleMultiSelectChange = (event) => {
		var currentState = { ...this.state.userInEdit };
		currentState.permissions = [ ...event.target.value ];
		this.setState({
			userInEdit: currentState
		});
	};

	handlePostionChange = (event) => {
        let target = event.target;
        const value = target.value;
        const edited = JSON.parse(JSON.stringify(this.state.userInEdit));
		edited.positionName = value.name;
		edited.position = value;
		this.setState({
			userInEdit: edited
		});
    }

    handleStateChange = (event) => {
        const edited = this.state.userInEdit;
        edited.mailingStateId = event.target.value.id;
        edited.state = event.target.value;

        this.setState({
            edited
        })
    };


	render() {
        return (
            <div>
                {!this.state.userInEdit.userID ?
                    <h2 className="adjust-dist-title">Add New User</h2> :
                    <h2 className="adjust-dist-title">Edit User</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="firstName">First Name</label>
						<Input
							required={true}
							type="text"
							name="firstName"
							id="firstName"
							value={this.state.userInEdit.firstName || ''}
							onChange={this.onDialogInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="lastName">Last Name</label>
						<Input
							required={true}
							type="text"
							name="lastName"
							id="lastName"
							value={this.state.userInEdit.lastName || ''}
							onChange={this.onDialogInputChange}
						/>
                    </div>
                    <div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="email">Email</label>
                        <Input
                            required={true}
                            type="email"
                            name="email"
                            id="email"
                            value={this.state.userInEdit.email || ''}
                            onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.emailMessage}</p>
                    </div>
                    <div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="firstName">Address 1</label>
                        <Input
                            required={true}
                            type="text"
                            name="mailingAddress1"
                            id="mailingAddress1"
                            value={this.state.userInEdit.mailingAddress1 || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>

                    <div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="firstName">Address 2</label>
                        <Input
                            type="text"
                            name="mailingAddress2"
                            id="mailingAddress2"
                            value={this.state.userInEdit.mailingAddress2 || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
                    <div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="firstName">City</label>
                        <Input
                            required={true}
                            type="text"
                            name="mailingCity"
                            id="mailingCity"
                            value={this.state.userInEdit.mailingCity || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
                    <div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="State">State </label>
                        <DropDownList data={this.props.common.states}
                            id="mailingState"
                            name="mailingState"
                            textField="name"
                            dataItemKey="id"
                            onChange={this.handleStateChange}
                            value={this.state.userInEdit.state}
                        />
                    </div>
                    <div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="firstName">Zip</label>
                        <Input
                            required={true}
                            type="text"
                            name="mailingZip"
                            id="mailingZip"
                            value={this.state.userInEdit.mailingZip || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
					<div className="form-group col-md-12 col-lg-6">
						<label for="phone">Phone</label>
						<Input
							type="text"
							name="phone"
							id="phone"
							value={this.state.userInEdit.phone || ''}
							onChange={this.onDialogInputChange}
						/>
					</div>
					<div className="form-group col-md-12 col-lg-6">
                        <label htmlFor="permissions">Permissions</label>
						<MultiSelect
							required={true}
							data={this.props.permissions}
							onChange={this.handleMultiSelectChange}
							value={this.state.userInEdit.permissions}
							textField="claimName"
							dataItemKey="claimID"
							allowCustom={true}
							id="permissions"
                            name="permissions"
                            className="multiSelection"
						/>
					</div>
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.userInEdit.userID ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
                </form>
            </div>
		);
	}
}

function mapStateToProps(state) {
	return {
        position: state.position,
        common: state.common
	};
}

export default connect(mapStateToProps, { fetchPositions, fetchStates, getPermissions })(UserForm);